import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import Cookies from "js-cookie";



Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    status: "",
    token: Cookies.get("token") || "",
    user: null,
    users: {},
    defaultAvatar: 'https://images.sports4me.at/img/default-avatar.png',
    isAdmin: null,
    isDev: null,
    challenges: {
      available: null,
      joined: null,
      done: null
    },
    activityDetail: null,
  },
  mutations: {
    loading(state) {
      state.status = "loading";
    },
    success(state) {
      state.status = "success";
    },
    error(state) {
      state.status = "error";
    },
    auth_request(state) {
      state.status = "loading";
    },
    auth_success(state, data) {
      state.status = "success";
      state.token = data.token;
      state.user = data.user;
      state.isAdmin = this.getters.isAdmin || false;
      state.isDev = this.getters.isDev || false;
    },
    auth_error(state) {
      state.status = "error";
    },
    logout(state) {
      state.status = "";
      state.token = "";
      state.user = null;
      state.isAdmin = null;
    },
    request_user(state) {
      state.status = "loading";
    },
    user_loaded(state, user) {
      state.status = "success";
      state.user = user;
      state.isAdmin = this.getters.isAdmin || false;
    },
    user_update_request(state) {
      state.status = "loading";
    },
    user_update_success(state, user) {
      state.status = "success";
      state.user = user;
    },
    setUser(state, data) {
      this.state.user[data.field] = data.value;
    },
    // challenge_request(state) {
    //   state.status = "loading";
    // },
    // challenge_success(state, data) {
    //   state.status = "success";
    //   state.challenges[data.type] = data.value;
    // },
    challenge_submit_request(state) {
      state.status = "loading";
    },
    challenge_submit_success(state) {
      state.status = "success";
    },
    friends_request(state) {
      state.status = "loading";
    },
    friends_success(state) {
      state.status = "success";
    },
    friends_error(state) {
      state.status = "error";
    },
    uploadAvatar_request(state) {
      state.status = "loading";
    },
    uploadAvatar_success(state, data) {
      if (data.image) {
        this.state.user.image = data.image;
      }
      state.status = "success";
    },
    uploadAvatar_error(state) {
      state.status = "error";
    },
    badge_request(state) {
      state.status = "loading";
    },
    badge_success(state, data) {
      state.status = "success";
    },
    badge_error(state) {
      state.status = "error";
    },
    strava_request(state) {
      state.status = "loading";
    },
    strava_success(state, data) {
      state.status = "success";
      state.stravaCode = data.code;
    },
    strava_error(state) {
      state.status = "error";
    },
    garmin_request(state) {
      state.status = "loading";
    },
    garmin_success(state, data) {
      state.status = "success";
      state.garminAuthorizationLink = data.authorizationLink;
    },
    garmin_error(state) {
      state.status = "error";
    },
    app_request(state, data) {
      state.status = data.status;
      if (data.authorizationLink) {
        state.appAuthorizationLink = data.authorizationLink;
      }
    },
    activity_success(state, data) {
      state.status = "success";
      state.activityDetail = data;
    },
  },
  actions: {
    login({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios({
          url: process.env.VUE_APP_BACKEND_URL + "/rpc/auth/login",
          data: user,
          method: "POST"
        })
          .then(resp => {
            const token = resp.data.token;
            const userData = resp.data.user;
            // Set AWT Token
            Cookies.set("token", token, { expires: 60 });
            // Use AWT token for future requests
            axios.defaults.headers.common["Authorization"] = "Bearer " + token;
            // Set user, isLoggedIn and token state
            commit("auth_success", { token: token, user: userData });
            resolve(resp);
          })
          .catch(err => {
            commit("auth_error");
            Cookies.remove("token");
            reject(err);
          });
      });
    },
    register({ commit }, options) {
      if(options.cmd && (options.cmd == 'activate' || options.cmd == 'unsubscribe')) {
        return new Promise((resolve, reject) => {
          commit("auth_request");
          axios({
            url: process.env.VUE_APP_BACKEND_URL + "/rpc/auth/" + options.cmd,
            data: options.token,
            method: "POST"
          })
            .then(resp => {
              resolve({cmd: options.cmd, res: resp.data});
            })
            .catch(err => {
              reject(err);
            });
        });
      } else {
        return new Promise((resolve, reject) => {
          commit("auth_request");
          axios({
            url: process.env.VUE_APP_BACKEND_URL + "/rpc/auth/register",
            data: options,
            method: "POST"
          })
            .then(resp => {
              // Same as in Login
              const token = resp.data.token;
              const userData = resp.data.user;
              Cookies.set("token", token, { expires: 60 });
              axios.defaults.headers.common["Authorization"] = "Bearer " + token;
              commit("auth_success", { token: token, user: userData });
              resolve(resp);
            })
            .catch(err => {
              commit("auth_error", err);
              Cookies.remove("token");
              reject(err);
            });
        });
      }
    },
    logout({ commit }) {
      return new Promise((resolve, reject) => {
        commit("logout");
        // AWT token delete
        Cookies.remove("token");
        // Requests wont use token anymore
        delete axios.defaults.headers.common["Authorization"];
        resolve();
      });
    },
    // default is GET, but could also be used for DELETE
    queryAPI({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("loading");
        let options = data.options || null;
        Object.keys(options || []).forEach(key => options[key] === undefined || options[key] === '' ? delete options[key] : {});
        let qParam = axios({
          url: process.env.VUE_APP_BACKEND_URL + data.url,
          params: options || "",
          method: data.method || "GET"
        })
          .then(res => {
            commit("success");
            resolve(res.data);
          })
          .catch(err => {
            commit("error");
            reject(err.response.data);
          });
      });
    },
    postAPI({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("loading");
        let qParam = axios({
          url: process.env.VUE_APP_BACKEND_URL + data.url,
          data: data.data,
          method: data.method || "POST"
        })
          .then(res => {
            commit("success");
            resolve(res.data);
          })
          .catch(err => {
            commit("error");
            reject(err.response.data);
          });
      });
    },

    loadRegisteredUsers({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("loading");
        let qParam =
          data.count == true ? "count=true"
            : `pageSize=${data.pageSize}&page=${data.page}&search=${data.search}&sort=${data.sort}&sortOrder=${data.sortOrder}`;

        if (data.filter) {
          qParam = qParam + `&filter=${data.filter}`;
        }

        axios({
          url:
            process.env.VUE_APP_BACKEND_URL +
            "/rest/challenge/dashboard/registration/" +
            data.id +
            "?" +
            qParam,
          method: "GET"
        })
          .then(res => {
            commit("success");
            resolve(res.data);
          })
          .catch(err => {
            commit("error");
            reject(err.response.data);
          });
      });
    },
    loadUser({ commit }, userId) {
      if(!this.state.users[userId]) {
        return axios.get(process.env.VUE_APP_BACKEND_URL + "/rest/user/public",{ params:{userId: userId}}).then(res => {this.state.users[userId] = res.data; return res.data})
      }
      return this.state.users[userId];
    },
    getUser({ commit }) {
      if (this.state.token) {
        console.log('set my TOKEN:', this.state.token);
        axios.defaults.headers.common["Authorization"] = "Bearer " + this.state.token;
      }
      return new Promise((resolve, reject) => {
        commit("request_user");
        axios({
          url: process.env.VUE_APP_BACKEND_URL + "/rest/user/me",
          method: "GET"
        })
          .then(res => {
            commit("user_loaded", res.data);
            resolve();
          })
          .catch(err => {
            commit("auth_error");
            Cookies.remove("token");
            reject(err);
          });
      });
    },
    updateUser({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("user_update_request");
        axios({
          url: process.env.VUE_APP_BACKEND_URL + "/rest/user/me",
          method: "PATCH",
          data: user
        })
          .then(res => {
            commit("user_update_success", res.data);
            resolve();
          })
          .catch(err => {
            reject(err.response.data);
          });
      });
    },
    sendUserFriendInvite({ commit }, id) {
      return new Promise(( resolve, reject) => {
        commit("friends_request");
        axios({
          url: process.env.VUE_APP_BACKEND_URL + "/rest/user/invite/" + id,
          method: "PUT"
        })
        .then(res => {
          commit("friends_success");
          // console.log("Done:", res.data)
          resolve(res.data);
        })
        .catch(err => {
          commit("friends_error");
          reject(err.response.data);
        });
      });
    },
    resendUserFriendInvite({ commit }, id){
      return new Promise(( resolve, reject) => {
        commit("friends_request");
        axios({
          url: process.env.VUE_APP_BACKEND_URL + "/rest/user/reinvite/" + id,
          method: "PUT"
        })
        .then(res => {
          commit("friends_seccess");
          // console.log("Done:", res.data)
          resolve(res.data);
        })
        .catch(err => {
          commit("friends_error");
          reject(err.response.data);
        })
      })
    },
    cancelFriendInvite({ commit }, id) {
      return new Promise(( resolve, reject) => {
        commit("friends_request");
        axios({
          url: process.env.VUE_APP_BACKEND_URL + "/rest/user/disinvite/" + id,
          method: "PUT"
        })
        .then(res => {
          commit("friends_success");
          // console.log("Done:", res.data)
          resolve(res.data);
         })
        .catch(err => {
          commit("friends_error");
          reject(err.response.data);
         });
      });
    },
    loadMyInvited({ commit }) {
      return new Promise(( resolve, reject) => {
        commit("friends_request");
        axios({
          url: process.env.VUE_APP_BACKEND_URL + "/rest/user/myInvited",
          method: "GET"
        })
        .then(res => {
          commit("friends_success");
          // console.log("Done:", res.data);
          resolve(res.data);
        })
        .catch(err => {
          commit("friends_error");
          reject(err.response.data);
        });
      });
    },
    loadMyInvitations({ commit }) {
      return new Promise((resolve, reject) => {
        commit("friends_request");
        axios({
          url: process.env.VUE_APP_BACKEND_URL + "/rest/user/myInvitations",
          method: "GET"
        })
        .then(res => {
          commit("friends_success");
          // console.log("Done:", res.data);
          resolve(res.data);
        })
        .catch(err => {
          commit("friends_error");
          reject(err.response.data);
        });
      });
    },
    connectWithUser({ commit }, id) {
      return new Promise((resolve, reject) => {
        commit("friends_request");
        axios({
          url: process.env.VUE_APP_BACKEND_URL + "/rest/user/connect/" + id,
          method: "PUT",
        })
        .then(res => {
          commit("friends_success");
          // console.log("Done:", res.data)
          resolve(res.data);
        })
        .catch(err => {
          commit("friends_error");
          reject(err.response.data);
        });
      });
    },
    ignoreFriendsRequest({ commit }, id) {
      return new Promise((resolve, reject) => {
        commit("friends_request");
        axios({
          url: process.env.VUE_APP_BACKEND_URL + "/rest/user/ignore/" +id,
          method: "PUT",
        })
        .then(res => {
          commit("friends_success");
          resolve(res.data);
        })
        .catch(err => {
          commit("friends_error");
          reject(err.response.data);
        })
      })
    },
    loadSearchedFriends({ commit }, searchQuery) {
      return new Promise((resolve, reject) => {
        commit("friends_request");
        axios({
          url: process.env.VUE_APP_BACKEND_URL + "/rest/user/search",
          method: "POST",
          data: searchQuery
        })
        .then(res => {
          commit("friends_success")
          resolve(res.data);
        })
        .catch(err => {
          commit("friends_error");
          reject(err.response.data);
        })
      })
    },
    submitChallengeForm({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("challenge_submit_request");
        axios({
          url:
            process.env.VUE_APP_BACKEND_URL +
            "/rest/challenge/" +
            data.id +
            "/joined/me",
          method: "PUT",
          data: data.form
        })
          .then(res => {
            commit("challenge_submit_success");
            resolve();
          })
          .catch(err => {
            reject(err.response.data);
          });
      });
    },
    uploadAvatar({ commit }, formData) {
      return new Promise((resolve, reject) => {
        commit("uploadAvatar_request");
        return axios({
          url: process.env.VUE_APP_BACKEND_URL + "/rest/image/avatar",
          // url: process.env.VUE_APP_BACKEND_URL + "/rest/user/uploadAvatar",
          method: "POST",
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
          .then(res => {
            commit("uploadAvatar_success", res.data);
            resolve(res.data);
          })
          .catch(err => {
            reject(err.response.data);
            commit("uploadAvatar_error");
          });

        resolve();
        reject();
      });
    },
    uploadImage({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("loading");
        return axios({
          url: process.env.VUE_APP_BACKEND_URL + data.url,
          method: "POST",
          data: data.formData,
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
          .then(res => {
            commit("success", res.data);
            resolve(res.data);
          })
          .catch(err => {
            reject(err.response.data);
            commit("error");
          });
      });
    },
    strava({ commit }, code) {
      let options = {};
      if (code === false) {
        options = {
          url:
            process.env.VUE_APP_BACKEND_URL +
            "/rpc/services/strava/removeToken",
          method: "GET"
        };
      } else {
        options = {
          url: process.env.VUE_APP_BACKEND_URL + "/rpc/services/strava",
          method: "POST",
          data: code
        };
      }
      return new Promise((resolve, reject) => {
        commit("strava_request");
        return axios(options)
          .then(res => {
            // get user object back
            commit("strava_success", { code: "" });
            resolve(true);
          })
          .catch(err => {
            commit("strava_error");
            if (!err.response) reject(err);
            reject(err.response.data);
          });

        resolve();
        reject();
      });
    },
    garmin({ commit }, cmd) {
      let options = {};
      if (cmd === "remove") {
        options = {
          url:
            process.env.VUE_APP_BACKEND_URL +
            "/rpc/services/garmin/removeToken",
          method: "GET"
        };
      } else {
        options = {
          url:
            process.env.VUE_APP_BACKEND_URL + "/rpc/services/garmin/activate",
          method: "POST"
        };
      }
      return new Promise((resolve, reject) => {
        commit("garmin_request");
        axios(options)
          .then(res => {
            commit("garmin_success", { authorizationLink: null });
            resolve(true);
          })
          .catch(err => {
            commit("garmin_error");
            if (!err.response) reject(err);
            reject(err.response.data);
          });

        resolve();
        reject();
      });
    },
    getGarminAuthorizationLink({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("garmin_request");
        return axios({
          url: process.env.VUE_APP_BACKEND_URL + "/rpc/services/garmin",
          method: "POST",
          data: user
        })
          .then(res => {
            commit("garmin_success", {
              authorizationLink: res.data.authorizationLink
            });
            resolve(res.data);
          })
          .catch(err => {
            commit("garmin_error");
            if (!err.response) reject(err);
            reject(err.response.data);
          });
      });
    },
    getAuthorizationLink({ commit }, { sourceName, returnUrl }) {
      return axios({
        url:
          process.env.VUE_APP_BACKEND_URL +
          "/rpc/services/" +
          sourceName +
          "/getAuthorizationLink",
        method: "GET",
        params: {
          returnUrl
        }
      }).then(res => res.data);
    },
    removeAuthorization({ commit }, { sourceName }) {
      return axios({
        url:
          process.env.VUE_APP_BACKEND_URL +
          "/rpc/services/" +
          sourceName +
          "/removeAuthorization",
        method: "POST"
      }).then(res => res.data);
    },
    testNotification({}, { push }) {
      return axios({
        url:
          process.env.VUE_APP_BACKEND_URL +
          "/rest/notfication/test?push=" +
          (push || false),
        method: "GET"
      }).then(res => res.data);
    },
    createActivity({}, activity) {
      return axios({
        url: process.env.VUE_APP_BACKEND_URL + "/rest/activity/createForMe",
        data: activity,
        method: "POST"
      }).then(res => res.data);
    },
    exportResults({}, challengeId) {
      axios({
        url:
          process.env.VUE_APP_BACKEND_URL +
          "/rest/challenge/" +
          challengeId +
          "/exportRegistrations/getToken",
        method: "GET"
      })
        .then(res => {
          if (res.data && res.data.token) {
            let url =
              process.env.VUE_APP_BACKEND_URL +
              "/rest/challenge/" +
              challengeId +
              "/exportRegistrations/" +
              res.data.token;
            window.open(url, "_blank");
          }
        })
        .catch(err => {
          reject(err.response.data);
        });
    },
    requestNewPassword({ commit }, email) {
      return new Promise((resolve, reject) => {
        commit("loading");
        axios({
          url: process.env.VUE_APP_BACKEND_URL + "/rpc/auth/forgot-password",
          method: "POST",
          data: { email: email }
        })
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err.response.data);
          });
      });
    },
    checkPasswordCode({ commit }, { code, password }) {
      return new Promise((resolve, reject) => {
        commit("loading");
        axios({
          url: process.env.VUE_APP_BACKEND_URL + "/rpc/auth/reset-password",
          method: "POST",
          data: { code: code, password: password }
        })
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err.response.data);
          });
      });
    },
    sendContact({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("loading");
        axios({
          url: process.env.VUE_APP_BACKEND_URL + "/rest/contact",
          method: "POST",
          data: data
        })
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err.response.data);
          });
      });
    },
    loadMyLeaderboard({ commit }, data) {
      return axios({
        url:
          process.env.VUE_APP_BACKEND_URL +
          "/rest/challenge/" +
          data.challengeId +
          "/result/me",
        method: "GET"
      }).then(res => res.data);
    },
    loadLeaderboard({ commit }, data) {
      return axios({
        url:
          process.env.VUE_APP_BACKEND_URL +
          "/rest/challenge/" +
          data.challengeId +
          "/results",
        method: "GET",
        params: {
          sort: data.sort,
          sortOrder: data.sortOrder,
          search: data.search,
          filter: data.filter || null,
          page: data.page,
          pageSize: data.pageSize
        }
      }).then(res =>
        res.data.map(item => {
          let dataList = item.data || [];
          item.data = {};
          dataList.forEach(entry => (item.data[entry.name] = entry.value));
          return item;
        })
      );
    },
    loadChallengeResultsCount({ commit }, data) {
      return axios({
        url:
          process.env.VUE_APP_BACKEND_URL +
          "/rest/challenge/" +
          data.challengeId +
          "/count",
        method: "GET"
      })
        .then(res => res.data)
        .catch(err => err.response);
    },
    loadChallengeResultDocuments({ commit }, data) {
      return axios({
        url:
          process.env.VUE_APP_BACKEND_URL +
          "/rest/challenge/" +
          data.challengeId +
          "/documents",
        method: "GET"
      })
        .then(res => {
          commit("activity_success")
          resolve(res.data)
        })
        .catch(err => err.response);
    },
    adminLoadUserActivities({ commit }, data) {
      return axios({
        url:
          process.env.VUE_APP_BACKEND_URL +
          "/rpc/activity/getForUser/" +
          data.userId
      }).then(res => res.data);
    },
    loadFriends({ commit }) {
      return new Promise((resolve, reject) => {
        commit("friends_request");
        axios({
          url: process.env.VUE_APP_BACKEND_URL + "/rest/user/myFriends",
          method: "GET"
        })
        .then(res => {
          commit("friends_success");
          resolve(res.data);
        })
        .catch(err => {
          commit("friends_error");
          reject(err.response.data);
        });
      });
    },
    disconnectWithFriend({ commit }, id) {
      return new Promise((resolve, reject) => {
        commit("friends_request");
        axios({
          url: process.env.VUE_APP_BACKEND_URL + "/rest/user/disconnect/" + id,
          method: "PUT"
        })
        .then(res => {
          commit("friends_success");
          resolve(res.data);
        })
        .catch(err => {
          commit("friends_error");
          reject(err.response.data);
        });
      });
    },
    adminAssignResultActivity({ commit }, data) {
      return axios({
        url:
          process.env.VUE_APP_BACKEND_URL +
          "/rpc/challenge/assignChallengeRegistrationWithActivity",
        data: {
          challengeRegistrationId: data.challengeRegistrationId,
          activityId: data.activityId
        },
        method: "POST"
      }).then(res =>
        axios({
          url:
            process.env.VUE_APP_BACKEND_URL +
            "/rpc/challenge/patchChallengeRegistrationRank",
          data: {
            challengeRegistrationId: data.challengeRegistrationId
          },
          method: "POST"
        })
      );
    },
    adminAssignResultValues({ commit }, data) {
      return axios({
        url:
          process.env.VUE_APP_BACKEND_URL +
          "/rpc/challenge/assignChallengeRegistrationWithValues",
        data: {
          challengeRegistrationId: data.challengeRegistrationId,
          duration: data.duration,
          distance: data.distance
        },
        method: "POST"
      }).then(res =>
        axios({
          url:
            process.env.VUE_APP_BACKEND_URL +
            "/rpc/challenge/patchChallengeRegistrationRank",
          data: {
            challengeRegistrationId: data.challengeRegistrationId
          },
          method: "POST"
        })
      );
    },
    getActivityDetails({ commit }, activityId) {
      return axios({
        url:
            process.env.VUE_APP_BACKEND_URL +
            "/rest/activity/get/" +
            activityId,
        method: "GET"
      })
          .then(res => res.data)
          .catch(err => err.response);
    },
  },
  getters: {
    isLoggedIn: state => !!state.token,
    isAdmin: state =>
      state.admin
        ? true
        : state.user && state.user.roles
        ? state.user.roles.includes("admin")
        : false,
    isDev: state =>
      state.user && state.user.roles
        ? state.user.roles.includes("developer")
        : false,
    isOrganizer: state =>
    state.user && state.user.roles
      ? state.isAdmin || state.user.roles.includes("organizer")
      : false,
    isCompany: state =>
      state.user && state.user.roles
      ? state.isAdmin || state.user.roles.includes("company")
      : false,
    authStatus: state => state.status,
    user: state => {
      return state.user;
    },
    getAvailableChallengeById: state => id => {
      if (state.challenges.available) {
        return state.challenges.available.find(
          challenge => challenge._id === id
        );
      } else return null;
    }
  }
});
